import React from 'react';
import { Modal } from 'react-bootstrap';

const NumberDetails = ({
  userDetailsModal,
  setUserDetailsModal,
  userDetails,
  setUserDetails,
}) => {
  const {
    customer,
    did_number,
    did_name,
    did_setup_cost,
    did_monthly_cost,
    did_status,
    amount,
    renewal_date,
    did_city,
    did_city_prefix,
  } = userDetails;

  const fullname = !customer?.firstname
    ? '---'
    : ` ${customer?.firstname || ''} ${customer?.lastname || ''}
`;

  const handleClose = () => {
    setUserDetailsModal(false);
    setUserDetails({});
  };

  return (
    <>
      <Modal
        size="lg"
        centered
        show={userDetailsModal}
        onHide={() => handleClose()}
        keyboard={false}
        backdrop="static"
      >
        <div className="modal-header">
          <h5 className="modal-title ">Number Detail</h5>
        </div>
        <div className="modal-body user-detail-modal">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">Customer Name:</label>
                <small>{fullname ? fullname : '---'}</small>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove"> DID Number:</label>
                <small>{did_number ? did_number : '---'}</small>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">DID Name:</label>
                <small>{did_name ? did_name : '---'}</small>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">DID Setup Cost:</label>
                <small>{did_setup_cost}</small>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">DID Monthly Cost:</label>
                <small>{did_monthly_cost}</small>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">DID Status::</label>
                <small>
                  {did_status === 'A' ? 'Activated' : 'Deactivated'}
                </small>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">Paid:</label>
                <small>{amount}</small>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">Renewable Date:</label>
                <small>{renewal_date ? renewal_date : '---'}</small>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">DID City:</label>
                <small>{did_city ? did_city : '---'}</small>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="labelMove">DID City Prefix:</label>
                <small>{did_city_prefix ? did_city_prefix : '---'}</small>
              </div>
            </div>

            <div className="col-md-12 text-right">
              <button
                type="button"
                onClick={() => handleClose()}
                className="btn btn-default"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default NumberDetails;
